import Instance from "./Instance";

const TYPE = 'upload-sftp';

export default interface Config {
    type: string
    active: boolean
    config: Instance,
    fullQualifier: string,
    qualifier: string,
    status: {}
}

export { TYPE }